import { createComponent, isPoint } from "../utils";

export default createComponent({
  name: "Move",
  description: "Move geometry",
  group: "Transform",
  icon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512.006 512.006"
    >
      <path
        fill="currentColor"
        d="M508.247,246.756l-72.457-72.465c-5.009-5.009-13.107-5.009-18.116,0c-5.009,5.009-5.009,13.107,0,18.116l50.594,50.594    H268.811V43.748l50.594,50.594c5.009,5.009,13.107,5.009,18.116,0c5.009-5.009,5.009-13.107,0-18.116L265.056,3.761    c-5.001-5.009-13.107-5.009-18.116,0l-72.457,72.457c-5.009,5.009-5.009,13.107,0,18.116c5.001,5.009,13.107,5.009,18.116,0    l50.594-50.594v199.27H43.744l50.594-50.594c5.009-5.009,5.009-13.107,0-18.116c-5.009-5.009-13.107-5.009-18.116,0L3.757,246.756    c-5.009,5.001-5.009,13.107,0,18.116l72.465,72.457c5.009,5.009,13.107,5.009,18.116,0c5.009-5.001,5.009-13.107,0-18.116    l-50.594-50.594h199.458v199.646l-50.594-50.594c-5.009-5.001-13.107-5.001-18.116,0c-5.009,5.009-5.009,13.107,0,18.116    l72.457,72.465c5,5,13.107,5,18.116,0l72.465-72.457c5.009-5.009,5.009-13.107,0-18.116c-5.009-5-13.107-5-18.116,0    l-50.594,50.594V268.627h199.458l-50.594,50.594c-5.009,5.009-5.009,13.107,0,18.116s13.107,5.009,18.116,0l72.465-72.457    C513.257,259.872,513.257,251.765,508.247,246.756z"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "geometry",
      name: "Geometry",
      type: "Geometry",
    },
    {
      id: "motion",
      name: "Motion",
      type: "Vector",
    },
  ],
  outputs: [
    {
      id: "moved",
      name: "Geometry",
      type: "Geometry",
      compute: ({ geometry, motion = [0, 0, 0] }) => {
        if (geometry?.translate) {
          const newGeometry = geometry.duplicate();
          newGeometry.translate(motion);
          return newGeometry;
        }
        if (isPoint(geometry)) {
          return [
            geometry[0] + motion[0],
            geometry[1] + motion[1],
            geometry[2] + motion[2],
          ];
        }
      },
    },
  ],
});
